import { api } from './client'
import type { Story } from './stories'

export type MyStory = Story & {
  project_key: string
  project_name: string
  project_color: string | null
}

export type MyDashboard = {
  stats: {
    todo: number
    in_progress: number
    in_review: number
    done: number
    due_today: number
    due_week: number
    overdue: number
    blocked: number
  }
  today: Array<{
    id: number
    key: string
    title: string
    priority: 'low' | 'med' | 'high'
    due_date: string | null
    estimate_points: number | null
    status_name: string
    status_category: string
    status_color: string | null
    epic_name: string | null
    epic_color: string | null
    project_key: string
    project_name: string
    project_color: string | null
  }>
}

export async function listMyStories(filters: {
  status_category?: string
  include_done?: 0 | 1
  priority?: 'low' | 'med' | 'high'
  project_id?: number
  due_from?: string
  due_to?: string
  q?: string
  per_page?: number
} = {}): Promise<MyStory[]> {
  // Backend returns `paginated` envelope; api() unwraps `data`. Use raw fetch to keep both.
  const url = new URL('/api/v1/me/stories', window.location.origin)
  for (const [k, v] of Object.entries(filters)) {
    if (v !== undefined && v !== null && v !== '') url.searchParams.set(k, String(v))
  }
  const token = localStorage.getItem('atlas_token')
  const res = await fetch(url.toString(), { headers: { Authorization: `Bearer ${token}` } })
  if (!res.ok) throw new Error(`HTTP ${res.status}`)
  const json = (await res.json()) as { data: MyStory[] }
  return json.data
}

export async function getMyDashboard(): Promise<MyDashboard> {
  return api<MyDashboard>('/me/dashboard')
}

export type MySprint = {
  id: number
  name: string
  goal: string | null
  status: 'planned' | 'active' | 'closed'
  start_date: string | null
  end_date: string | null
  /** Negative once the end date has passed. */
  days_left: number | null
  project: { id: number; key: string; name: string; color: string | null }
  story_count: number
  done_count: number
  in_progress_count: number
  my_story_count: number
  percent_done: number
  total_points: number
  done_points: number
  capacity_points: number | null
  open_stories: Array<{
    id: number
    key: string
    title: string
    priority: 'low' | 'med' | 'high'
    due_date: string | null
    status_name: string
    status_category: string
    assignee_id: number | null
    assignee_name: string | null
  }>
}

/** Sprints in play across my projects (active + planned-but-started). */
export async function getMySprints(): Promise<MySprint[]> {
  return api<MySprint[]>('/me/sprints')
}
